const STORAGE_KEY = 'fm_age_verified';
const TTL_DAYS = 30;
const REDIRECT_URL = 'https://www.epws.eu/wine-information-council/';

const isBot = () => {
  const ua = navigator.userAgent || '';
  return /bot|crawl|slurp|spider|mediapartners|googlebot|bingbot|yandex|baidu|duckduckbot|facebookexternalhit|whatsapp|telegram|twitter|linkedinbot/i.test(
    ua
  );
};

const isVerified = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return false;
    const data = JSON.parse(raw);
    if (!data || data.verified !== true) return false;
    if (typeof data.exp === 'number' && data.exp < Date.now()) {
      localStorage.removeItem(STORAGE_KEY);
      return false;
    }
    return true;
  } catch (_e) {
    return false;
  }
};

const setVerified = () => {
  try {
    const exp = Date.now() + TTL_DAYS * 24 * 60 * 60 * 1000;
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ verified: true, exp }));
  } catch (_e) {
    // localStorage non disponibile (es. modalità incognito con storage bloccato)
  }
};

class AgeGate extends HTMLElement {
  #confirmBtn = null;
  #denyBtn = null;
  #handleKeydown = null;
  #previousActiveElement = null;

  connectedCallback() {
    if (isBot()) return;
    if (isVerified()) return;
    if (window.Shopify && window.Shopify.designMode) return;

    this.#confirmBtn = this.querySelector('[data-age-gate-confirm]');
    this.#denyBtn = this.querySelector('[data-age-gate-deny]');

    if (!this.#confirmBtn || !this.#denyBtn) return;

    this.#confirmBtn.addEventListener('click', this.#handleConfirm);
    this.#denyBtn.addEventListener('click', this.#handleDeny);

    this.#previousActiveElement = document.activeElement;
    this.removeAttribute('hidden');
    this.classList.add('is-visible');
    document.body.classList.add('age-gate-locked');

    this.#handleKeydown = (event) => {
      if (event.key === 'Escape' || event.key === 'Tab') {
        if (event.key === 'Escape') {
          event.preventDefault();
          return;
        }
        const focusables = [this.#confirmBtn, this.#denyBtn];
        const idx = focusables.indexOf(document.activeElement);
        if (idx === -1) {
          event.preventDefault();
          this.#confirmBtn.focus();
          return;
        }
        const next = event.shiftKey ? idx - 1 : idx + 1;
        if (next < 0 || next >= focusables.length) {
          event.preventDefault();
          focusables[event.shiftKey ? focusables.length - 1 : 0].focus();
        }
      }
    };
    document.addEventListener('keydown', this.#handleKeydown);

    setTimeout(() => this.#confirmBtn?.focus(), 50);
  }

  disconnectedCallback() {
    this.#confirmBtn?.removeEventListener('click', this.#handleConfirm);
    this.#denyBtn?.removeEventListener('click', this.#handleDeny);
    if (this.#handleKeydown) {
      document.removeEventListener('keydown', this.#handleKeydown);
    }
    document.body.classList.remove('age-gate-locked');
  }

  #handleConfirm = (event) => {
    event.preventDefault();
    setVerified();
    this.#close();
  };

  #handleDeny = (event) => {
    event.preventDefault();
    window.location.replace(REDIRECT_URL);
  };

  #close() {
    this.classList.remove('is-visible');
    this.setAttribute('hidden', '');
    document.body.classList.remove('age-gate-locked');
    if (this.#previousActiveElement && typeof this.#previousActiveElement.focus === 'function') {
      try {
        this.#previousActiveElement.focus();
      } catch (_e) {
        // noop
      }
    }
  }
}

if (!customElements.get('age-gate')) {
  customElements.define('age-gate', AgeGate);
}
